import React, { useEffect, useState } from 'react'
import { Col, Container, FormSelect, Row } from 'react-bootstrap'
import { useNavigate, useParams } from 'react-router-dom'
import TablaSensor from '../Componentes/TablaSensor'
import { Sensor } from '../Interfaces/Interfaces'
import { obtenerSensores } from '../Promesas/Promesas'
import Menu from '../Componentes/Menu'
import { MenuItems } from '../Componentes/MenuItems'
import TablaSensorRangos from '../Componentes/TablaSensorRangos'


interface Props{
  hamburguesa:boolean;
  isLogin: boolean;
  ruta:'historico'|'mediciones'
}
export interface Options{
  val:"30"|"20"|"10"|"5"|"0";
}


const Dispositivo = (props:Props) => {
  const [sensores,setSensores] = useState<Sensor[]>([]);
  const [fCantidad,setFCantidad] = useState<string>("30")
  useEffect(()=>{
    if(!props.isLogin){
      navigate('/')
    }else{
      obtenerSensores(undefined,params.id).then((listado)=>{
        setSensores(listado);
      })
  
    }

    
  
    


  },[])
 
    const navigate = useNavigate()
    const params = useParams()


  
  return (
    <Row>
    <Menu key="menu1" menu={props.hamburguesa}>
      <MenuItems/>
    </Menu>
    <Col>
    <Container>
      <Row>
        <Col>
          <FormSelect onChange={(e)=>{setFCantidad(e.target.value)}}>
            
            
            <option  value="30">Ultimos 30</option>
            <option  value="20">Ultimos 20</option>
            <option  value="10">Ultimos 10</option>
            <option  value="5">Ultimos 5</option>
            <option  value="0">Todos</option>
          </FormSelect>
        </Col>
      </Row>
      <Row>
      {
      props.ruta == "historico" &&  
      sensores.map((s,index)=>{return(<Col><TablaSensor key={index} sensor={s} idDispositivo={params.id!} filtroCantidad={fCantidad} ></TablaSensor></Col>)})}

      {
      props.ruta == "mediciones" &&  
      sensores.map((s,index)=>{return(<Col><TablaSensorRangos key={index} sensor={s} idDispositivo={params.id!} filtroCantidad={fCantidad} ></TablaSensorRangos></Col>)})}

      </Row>
    </Container>
    </Col>
    </Row>
  )
}

export default Dispositivo
